import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UIFeatureKey, UIState } from '../reducers/ui.reducer';

export const selectUiState = createFeatureSelector<UIState>(UIFeatureKey);

export const selectCurrentSelectedDate = createSelector(
  selectUiState,
  (state) => state.currentSelectedDate
);

export const selectCurrentLocationId = createSelector(
  selectUiState,
  (state) => state.currentLocationId
);

export const selectCurrentMealId = createSelector(
  selectUiState,
  (state) => state.currentMealId
);

export const selectCurrentMenuType = createSelector(
  selectUiState,
  (state) => state.currentMenuType
);

export const selectCurrentLogoSrc = createSelector(
  selectUiState,
  (state) => state.currentLogoSrc
);

export const selectPrimaryDishColor = createSelector(
  selectUiState,
  (state) => state.primaryDishColor
);

export const selectAccentDishColor = createSelector(
  selectUiState,
  (state) => state.accentDishColor
);
